// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w3is","buttons":"styles_buttons__1MXC3"};